import { Image } from "lucide-react";
import { senderEmailForRemoteImages } from "@/lib/message/remoteImages";

type Props = {
  from?: string;
  onShowOnce: () => void;
  onAlwaysForSender: () => void;
};

export function RemoteImagesBanner({ from, onShowOnce, onAlwaysForSender }: Props) {
  const sender = from ? senderEmailForRemoteImages(from) : "";
  const canRemember = sender.includes("@");

  return (
    <div className="mail-remote-images-banner" role="status">
      <p className="mail-remote-images-banner__text">
        <Image className="mail-remote-images-banner__icon" aria-hidden />
        <span>Ce message charge des images depuis Internet.</span>
      </p>
      <div className="mail-remote-images-banner__actions">
        <button type="button" className="mail-remote-images-banner__btn mail-remote-images-banner__btn--primary" onClick={onShowOnce}>
          Afficher
        </button>
        {canRemember ? (
          <button type="button" className="mail-remote-images-banner__btn" onClick={onAlwaysForSender}>
            Toujours pour cet expéditeur
          </button>
        ) : null}
      </div>
    </div>
  );
}
